/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_LoadingInputs */

const en_us2_exercise_loading = /** @type {(inputs: Exercise_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading…`)
};

const pt_br2_exercise_loading = /** @type {(inputs: Exercise_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando…`)
};

const es_419_exercise_loading = /** @type {(inputs: Exercise_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando…`)
};

const pt_pt2_exercise_loading = /** @type {(inputs: Exercise_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar…`)
};

const fr_fr2_exercise_loading = /** @type {(inputs: Exercise_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement…`)
};

const de_de2_exercise_loading = /** @type {(inputs: Exercise_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird geladen…`)
};

const it_it2_exercise_loading = /** @type {(inputs: Exercise_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento…`)
};

/**
* | output |
* | --- |
* | "Loading…" |
*
* @param {Exercise_LoadingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_loading = /** @type {((inputs?: Exercise_LoadingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_LoadingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_loading(inputs)
	if (locale === "es-419") return es_419_exercise_loading(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_loading(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_loading(inputs)
	if (locale === "de-DE") return de_de2_exercise_loading(inputs)
	if (locale === "it-IT") return it_it2_exercise_loading(inputs)
	return en_us2_exercise_loading(inputs)
});
export { exercise_loading as "exercise.loading" }